import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import styled from 'styled-components';

import { Link } from 'core/routing';

import { ModalTitle, Divider, Center } from 'legacyComponents/styled/lib';
// FIXME: To remove ThemeColors import
import ThemeColors from 'styles/themes/wikifactory/styles/colors';
import { media } from 'legacyComponents/styled/styleUtils';
import { clientStore } from 'apps/client/app';
import { Paragraph } from 'components';
import { Modal } from 'apps/modals/views/modal';
import { PriceDetails as DetailsWrapper } from 'apps/payment/styles';

@withNamespaces()
@inject('routerStore')
@observer
export class PaymentOverdueModal extends Modal {
  render() {
    const { routerStore } = this.props;
    const { params } = routerStore;
    const spaceName =
      params.get('profile') ||
      params.get('initiative') ||
      params.get('spacePath');
    const settingsRouteName = `workspace.spaceSettings.billing`;
    const settingsRouteParams = {
      spacePath: spaceName || clientStore.activeSpace?.path,
    };

    return (
      <Wrapper>
        <ModalTitle color={ThemeColors.destructive}>
          <Trans>Action Required</Trans>
        </ModalTitle>
        <Divider />
        <Center>
          <Emoji>🖐</Emoji>
        </Center>
        <Title>
          <Trans>Looks like</Trans> {spaceName}&#39;s{' '}
          <Trans>subscription has expired</Trans>.
        </Title>
        <DetailsWrapper>
          <Paragraph>
            <Trans>
              To re-gain access to this private project, please consider
              re-activating the subscription.
            </Trans>
          </Paragraph>
          <Paragraph>
            <Trans>Speak to an admin or go to </Trans>
            <Link name={settingsRouteName} params={settingsRouteParams}>
              {spaceName}&#39;s <Trans>billing settings</Trans>
            </Link>
            .
          </Paragraph>
        </DetailsWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  padding: 0px 40px 20px 40px;
  ${media.xs`
    padding: 0px 20px 20px 20px;
  `};
`;

const Emoji = styled.p`
  font-size: 4em;
  color: black;
  margin: 20px 0px 0px 0px;
`;

const Title = styled.p`
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
`;
